import { connect } from 'react-redux';

import RcsSupplierInfoDialog from './RcsSupplierInfoDialog';

import { rcsSupplierInfoByIdFactory } from './RcsSupplierInfoDialogSelectors';


function mapStateToPropsFactory() {
  const rcsSupplierInfoById = rcsSupplierInfoByIdFactory();

  return (state, ownProps) => {

    return {
      supplierInfo: rcsSupplierInfoById(state, ownProps),
    };
  }
}

const mapDispatchToProps = {};

export default connect(mapStateToPropsFactory, mapDispatchToProps)(RcsSupplierInfoDialog);
